/**
 * Shared constants for the InfoPath attachment binary format and related verbale paths.
 * Used by both the XML→MyVerbale import pipeline and the MyVerbale→XML export pipeline.
 */

/** Base64 prefix of every InfoPath attachment payload (decodes to the magic bytes C7 49 46 41). */
export const INFOPATH_MAGIC_B64 = 'x0lGQR';

/** Size in bytes of the InfoPath attachment header (magic + 5 uint32 fields); filename starts at this offset. */
export const INFOPATH_HEADER_SIZE = 24;

/** XSI namespace — used to add/remove the `xsi:nil="true"` attribute on attachment elements. */
export const XSI_NS = 'http://www.w3.org/2001/XMLSchema-instance';
export const XHTML_NS = 'http://www.w3.org/1999/xhtml';

/** Prefix used by IndexedDBService when minting attachment IDs. Must stay in sync with IndexedDBService.idPrefix. */
export const INDEXED_DB_ID_PREFIX = 'confcooperative_allegato_key_';

/** Path within MyVerbale of the single Bilancio attachment (handled specially — keeps the real file rather than a placeholder). */
export const BILANCIO_ALLEGATO_PATH: readonly string[] = [
    'my_SezioneI__Rilevazione',
    'my_Bilancio',
    'my_BilancioAllegato',
];

/** Returns true if `path` points to the Bilancio attachment field. */
export function isBilancioAllegatoPath(path: readonly string[]): boolean {
    return (
        path.length === BILANCIO_ALLEGATO_PATH.length &&
        path.every((p, i) => p === BILANCIO_ALLEGATO_PATH[i])
    );
}

/**
 * Sets a value at a nested path inside an object/array tree. Path segments may be
 * object keys or stringified array indices ('0', '1', …) — JavaScript treats them
 * interchangeably when accessing arrays.
 *
 * Mutates `obj` in place.
 */
export function setNestedValue(obj: Record<string, unknown>, path: readonly string[], value: unknown): void {
    let current: Record<string, unknown> = obj;
    for (let i = 0; i < path.length - 1; i++) {
        current = current[path[i]] as Record<string, unknown>;
    }
    current[path[path.length - 1]] = value;
}
